import Anchor from 'models/application/anchor/Anchor';

export default class InternalStaticAnchor extends Anchor {
	_category = 'internal-static';
}
